import Vue from 'vue'
import VueRouter from 'vue-router'
import Hello from '@/components/HelloWorld'
import loginRoutes from './login'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  ...loginRoutes,
  {
    path: '/',
    name: 'Homepage',
    component: Hello,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresGuess = to.matched.some(x => x.meta.requiresGuess)
  if (requiresAuth && !store.getters.isAuthenticated) {
    next({ name: 'Login' })
  } else if (requiresGuess && store.getters.isAuthenticated) {
    next({ name: 'Homepage' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js